import React, { useState } from 'react'
import { Col, Row, Dropdown } from 'react-bootstrap'
import cursorIcon from '../../../../../../img/cursor-icon.png'
import openedIcon from '../../../../../../img/cursor-opened.png'
import deliveredIcon from '../../../../../../img/cursor-delivered.png'
import failedIcon from '../../../../../../img/cursor-failed.png'
import deferredIcon from '../../../../../../img/deferred-icon.png'
import DropdownMenu from '../../../../../universal/dropdown-menu'
import ReactTooltip from 'react-tooltip'
import { useSelector } from 'react-redux'
import { requestActiveEmailChannelStatistics, setActiveEmailChannelStatisticsDate } from '../../../../../../redux/actions/campaigns'
import { useDispatch } from 'react-redux'
import moment from 'moment'
import './style.scss'

const Index = () => {

    const dispatch = useDispatch()

    const statistics = useSelector(state => state.campaigns.activeChannel.statistics.data)
    const statisticsLoading = useSelector(state => state.campaigns.activeChannel.statistics.loading)

    const statisticsFilterDate = useSelector(state => state.campaigns.activeChannel.statistics.date)

    const selectedCompany = useSelector(state => state && state.activeCompany && state.activeCompany.activeCompany && state.activeCompany.activeCompany.id)
    const activeChannel = useSelector(state => state.campaigns.activeChannel)

    const [selectDateDropdownOpen, setSelectDateDropdownOpen] = useState(false)

    const renderStatistics = type => {
        if(!statisticsLoading){
            switch(type){
                case "delivered":
                    return statistics.delivered
                case "opened":
                    return statistics.opened
                case "clicked":
                    return statistics.clicked
                case "deferred":
                    return statistics.deferred
                case "bounces":
                    return statistics.bounces
                default:
                    return 0
            }
        } else {
            return <i className="fas fa-circle-notch fa-spin"></i>
        }
    }

    const handleSelectDate = e => {
        dispatch(setActiveEmailChannelStatisticsDate(e.dateStr))
        dispatch(requestActiveEmailChannelStatistics({companyId: selectedCompany, channelId: activeChannel.id, date: e.dateStr}))
    }


    const renderDropdownDate = () => {
        if(statisticsLoading){
            return "Laster inn"
        } else {
            if(statisticsFilterDate){
                return moment(statisticsFilterDate).format('DD/MM/YYYY')
            } else {
                return "Ikke tilgjengelig"
            }
        }
    }

    const renderDropdownToggle = () => {
        return(
            <Dropdown.Toggle onClick={() => setSelectDateDropdownOpen(!selectDateDropdownOpen)} disabled={statisticsLoading || !statisticsFilterDate ? true:false} id="dropdown-filter">
              {renderDropdownDate()} <i class="fad arrow fa-angle-down"></i>
            </Dropdown.Toggle>
        )
    }

    return(
        <div className="email-statistics-container">
            <hr/>
            <Row className="email-statistics-row">
                <Col className="single-detail-col stat">
                    <div className="inner-single-detail-container">
                        <div data-tip="E-post som har blitt levert til mottakeren." className="details-container">
                            <div className="icon-container">
                                <img className="icon" src={deliveredIcon}/>
                            </div>
                            <div className="stats-container">
                                <label className="title-label">Levert</label>
                                <label className="amount-label">{renderStatistics("delivered")}</label>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col className="single-detail-col stat">
                    <div className="inner-single-detail-container">
                        <div data-tip="E-post som har blitt åpnet av mottakeren." className="details-container">
                            <div className="icon-container">
                                <img className="icon" src={openedIcon}/>
                            </div>
                            <div className="stats-container">
                                <label className="title-label">Åpnet</label>
                                <label className="amount-label">{renderStatistics("opened")}</label>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col className="single-detail-col stat">
                    <div className="inner-single-detail-container">
                        <div data-tip="E-post med link som har blitt klikket på av mottakeren." className="details-container">
                            <div className="icon-container">
                                <img className="icon" src={cursorIcon}/>
                            </div>
                            <div className="stats-container">
                                <label className="title-label">Klikket</label>
                                <label className="amount-label">{renderStatistics("clicked")}</label>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col className="single-detail-col stat">
                    <div className="inner-single-detail-container">
                        <div data-tip="E-post venter på å bli og enda ikke har blitt sendt." className="details-container">
                            <div className="icon-container">
                                <img className="icon tall" src={deferredIcon}/>
                            </div>
                            <div className="stats-container">
                                <label className="title-label">På vent</label>
                                <label className="amount-label">{renderStatistics("deferred")}</label>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col className="single-detail-col stat">
                    <div className="inner-single-detail-container">
                        <div data-tip="E-post som har blitt sendt og ikke gått gjennom." className="details-container">
                            <div className="icon-container">
                                <img className="icon" src={failedIcon}/>
                            </div>
                            <div className="stats-container">
                                <label className="title-label">Feilet</label>
                                <label className="amount-label">{renderStatistics("bounces")}</label>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col className="single-detail-col select text-right">
                    <div className="inner-single-detail-container">
                        <DropdownMenu content="date" type="title" color="inverse-gray" size="regular" spacing="right" toggle={renderDropdownToggle()} title="Velg dato" actions={handleSelectDate} data={{selectedDate: statisticsFilterDate}} open={selectDateDropdownOpen} setOpen={setSelectDateDropdownOpen}/>
                    </div>
                </Col>
            </Row>
            <ReactTooltip/>         
        </div>
    )
}

export default Index